import { Tooltip } from "../Tooltip/Tooltip";

interface LeadTypeBadgeProps {
  originalLeadId?: string | null;
}

const LeadTypeBadge: React.FC<LeadTypeBadgeProps> = ({ originalLeadId }) => {
  const isSecondary = Boolean(originalLeadId);

  return (
    <Tooltip content={isSecondary ? "Secondary" : "Primary"}>
      <span
        className={`flex h-[18px] items-center rounded-full border px-[6px] py-[2px] text-sm font-medium shadow-xs ${
          isSecondary
            ? "bg-pure-white dark:bg-pure-white-dk border-border-gray dark:border-border-gray-dk text-verba-indigo dark:text-verba-indigo-dk"
            : "bg-applied-filters-tag-bg dark:bg-applied-filters-tag-bg-dk border-applied-filters-tag-bg dark:border-applied-filters-tag-bg-dk text-verba-blue dark:text-verba-blue-dk"
        }`}
      >
        {isSecondary ? "S" : "P"}
      </span>
    </Tooltip>
  );
};

export default LeadTypeBadge;
